const Image = ({ url }) => {
  return (
    <div className="section__image">
      <img src={url} width="100%" height="auto" alt="image" />
    </div>
  );
};

export default Image;
